import React from "react";
import { Link } from "react-router-dom";
import { useHasPermission } from "../../auth/useClaims";
import { useBranchFilter } from "../../branchFilter/useBranchFilter";
import { useListLposQuery } from "../../stock/stockApi";
import { paths } from "../../../routes/paths";
import StatusBadge from "../../../components/common/StatusBadge";
import DashboardSectionCard from "../components/DashboardSectionCard";

const RecentLposCard = () => {
  const canView = useHasPermission("Stock.ViewLpo");
  const { selectedBranchId } = useBranchFilter();

  const { data, isFetching } = useListLposQuery(
    { branchId: selectedBranchId ?? undefined, pageSize: 500 },
    { skip: !canView }
  );

  if (!canView) return null;

  const recent = (data?.items || []).slice(0, 5);

  return (
    <div className="col-12 col-xl-4">
      <DashboardSectionCard title="Recent LPOs" viewAllPath={paths.stockLpos} isLoading={isFetching} isEmpty={recent.length === 0}>
        <ul className="list-unstyled mb-0">
          {recent.map((lpo) => (
            <li key={lpo.recordGuid} className="d-flex justify-content-between align-items-center mb-2">
              <div>
                <Link to={paths.stockLpoDetail(lpo.recordGuid)} className="small fw-semibold text-decoration-none">
                  {lpo.lpoNumber}
                </Link>
                <div className="text-muted small">{lpo.supplierName}</div>
              </div>
              <StatusBadge status={lpo.status} />
            </li>
          ))}
        </ul>
      </DashboardSectionCard>
    </div>
  );
};

export default RecentLposCard;
